module.exports = __webpack_public_path__ + "static/media/amountButton.46ff4727.webp";